export function setDrawerItems (state, drawerItems) {
  state.drawerItems = drawerItems
}
